// extracted by mini-css-extract-plugin
module.exports = {"event_type":"Scheduler_event_type__JUo3K"};